<template>
    <div id="saas-header-lite"></div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'SaasHeader',
        props: {
            scriptLoading: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                initialized: false
            }
        },
        computed: {
            ...mapGetters(['user'])
        },
        methods: {
            ...mapActions(['logEvent']),
            createSaasHeaderLite() {
                if (this.initialized) return;
                
                try {
                    new window.ExperianSaaSComponent.SaasHeaderLite({
                        selector: 'saas-header-lite',
                        title: 'Home',
                        logoutPreHook: 'logoutFunction'
                    });
                    this.initialized = true;
                    this.$emit('ready');
                    this.logEvent("SaaS Header loaded and initialized.");
                } catch (error) {
                    this.logEvent("Error initializing SaaS Header: " + error);
                }
            },
            checkAndInitialize() {
                // Check if script is already loaded
                if (window.ExperianSaaSComponent && window.ExperianSaaSComponent.SaasHeaderLite) {
                    this.createSaasHeaderLite();
                }
            }
        },
        mounted() {
            // Try to initialize immediately in case script already loaded
            this.checkAndInitialize();
            
            // Listen for script load event from App.vue
            window.addEventListener('saas-header-script-loaded', this.checkAndInitialize);
        },
        beforeUnmount() {
            window.removeEventListener('saas-header-script-loaded', this.checkAndInitialize);
        }
    };
</script>
